import React from "react";
import Heading from "../ui/Heading";
import Slider from "react-slick";
import { Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
// import halo from "../assets/imges/shop-by-style/halo.png"
// import solitaire from "../assets/imges/shop-by-style/solitaire.png"
// import threeStone from "../assets/imges/shop-by-style/three-stone.png"
// import singleRow from "../assets/imges/shop-by-style/single-row.png"
// import multirow from "../assets/imges/shop-by-style/multirow.png"
// import bypass from "../assets/imges/shop-by-style/bypass.png"

const ShopRingByStyle = () => {
  const ringStyles = [
    { name: "Halo", image: "halo.webp",url:"Halo" },
    { name: "Solitaire", image: "Solitaire.webp", url: "Solitaire" },
    { name: "Three stone", image: "3 stone.webp", url: "Three Stone" },
    { name: "Single Row", image: "Single Row.webp", url: "Single Row" },
    { name: "Multirow", image: "Multirow.webp", url: "Multirow", },
    { name: "Bypass", image: "bypass.webp", url: "Bypass" },
    { name: "Solitaire", image: "Solitaire.webp", url: "Solitaire" },
  ];

  let settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    accessibility: true,
    arrows: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow: <Image src={`${ImageUrl}theme/showcase/left.png`} alt="arrow" />,
    nextArrow: <Image src={`${ImageUrl}theme/showcase/right.png`} alt="arrow" />,
    responsive: [
      {  breakpoint: 1024, settings: {slidesToShow: 3, arrows: false, dots: true}},
      {  breakpoint: 768, settings: {slidesToShow: 2, arrows: false, dots: true}},
    ],
    beforeChange: (current, next) => {
      document
        .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
        .forEach(el => el.setAttribute('tabindex', '-1'));
    },
    afterChange: () => {
      document
        .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
        .forEach(el => el.removeAttribute('tabindex'));
    }
  };

  return (
    <section className="shop-ring-by-style section-space">
      <Container fluid className="showcase-container">
        <Heading className="text-left">
          <h2>Shop Rings By Style</h2>
          <p>Explore  {Je_welryspelling}  Collections by Style and Make a Statement.</p>
        </Heading>

        <Slider {...settings2}>
        {ringStyles.map((ring, index) => (
            <div className="item" key={index}>
              <Link to={`/ringsettings/style=${ring.url}`}>
              <Image src={`${ImageUrl}theme/showcase/ring-style/${ring.image}`} alt={`${ring.name} Ring`} />
              </Link>
              <Link to={`/ringsettings/style=${ring?.url}`}>
                {ring?.name}
              </Link>
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default ShopRingByStyle;
